
import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';

declare module 'axios' {
  export interface AxiosRequestConfig {
    idempotencyKey?: string;
  }
}

const BACK_URL = process.env.REACT_APP_AMAT_API_URL;
const REQUEST_TIMEOUT = Number(process.env.REACT_APP_REQUEST_TIMEOUT ?? 45_000);

axios.defaults.withCredentials = true;



const getCookie = (name: string): string | undefined => {
	const cookies = document.cookie.split(';').map(c => c.trim());

	for (const cookie of cookies) {
		if (cookie.startsWith(`${name}=`)) {
			return decodeURIComponent(cookie.split('=')[1]);
		}
	}

	return undefined;
};


export const api: AxiosInstance = axios.create({
	baseURL: BACK_URL + '/sca-api',
	withCredentials: true,
	headers: {
		//'Accept': 'application/json',
	},
	timeout: REQUEST_TIMEOUT,
});

api.interceptors.request.use(async (config) => {
	// ajoute le header CSRF si le cookie est là (comme tu fais déjà)
	let xsrfToken = getCookie('XSRF-TOKEN');

	if (['post', 'put', 'delete', 'patch'].includes(config.method || '')) {
		if (!xsrfToken) {
			await axios.get(BACK_URL + '/sanctum/csrf-cookie', { withCredentials: true });
			xsrfToken = getCookie('XSRF-TOKEN');
		}

		//console.log('Payload is FormData?', config.data instanceof FormData);
		console.log('Content-Type header:', config.headers['Content-Type']);
	}
	if (xsrfToken && config.headers) {
		config.headers['X-XSRF-TOKEN'] = decodeURIComponent(xsrfToken);
	}

	if (config.idempotencyKey) {
		config.headers['Idempotency-Key'] = config.idempotencyKey
	}
	
	return config;
});


api.interceptors.request.use(
	(config) => {
		console.log(`[API] Request: ${config.method?.toUpperCase()} ${config.url}`);
		return config;
	},
	(error) => {
		console.error('[API] Request error:', error);
		return Promise.reject(error);
	}
);


api.interceptors.response.use(
	(response: AxiosResponse) => {
		console.log(`[API] Response: ${response.status} ${response.config.url}`);
		return response;
	},
	async (error: AxiosError) => {
		if (error.response) {
			const status = error.response.status;
			console.error(`[API] Response error ${status}:`, error.response.data);

			if (status === 401) {
				console.warn('Unauthorized - maybe redirect to login');
				// Tu peux rediriger ou vider le contexte utilisateur ici
			}

			if (status === 419) {
				console.warn('CSRF token mismatch — trying to refresh token and retry request...');

				try {
					// Rafraîchir le token CSRF
					await axios.get(BACK_URL + '/sanctum/csrf-cookie', {
						withCredentials: true,
					});
					sessionStorage.setItem('csrfTokenFetched', 'true');

					// Rejouer la requête originale
					const originalRequest = error.config!;

					const newToken = getCookie('XSRF-TOKEN');
					if (newToken) {
						originalRequest.headers['X-XSRF-TOKEN'] = decodeURIComponent(newToken);
					}

					return api(originalRequest); // <-- retry
				} catch (refreshError) {
					console.error('Failed to refresh CSRF token:', refreshError);
				}
			}
		} else {
			console.error('[API] Network or other error:', error.message);
		}

		return Promise.reject(error);
	}
);



export const initCSRF = async () => {
	try {
		await axios.get(BACK_URL + '/sanctum/csrf-cookie', { withCredentials: true });
	} catch (err) {
		console.error('CSRF init error', err);
	}
};